import { createFileRoute } from "@tanstack/react-router";

import { COMMUNITIES_PATH, legacyRedirectTo } from "@/lib/route-paths";

// Legacy bookmark: the old stack's `/dashboard` is the new app's landing page.
// It resolves to the landing destination rather than to `/` so the visitor
// takes one hop, not two — the observable destination is the contract term.
export const Route = createFileRoute("/_authed/_chrome/dashboard")({
  beforeLoad: legacyRedirectTo(COMMUNITIES_PATH),
});
